export const isValidId = () => {
	return new RegExp(/^(?:\w){8}-(?:\w){4}-(?:\w){4}-(?:\w){4}-(?:\w){12}$/);
};

export const validationRule = (id: string) => isValidId().test(id);
